import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { RunStartScene } from './scenes/RunStartScene';
import { RoundScene } from './scenes/RoundScene';
import { ShopScene } from './scenes/ShopScene';
import { WinScene } from './scenes/WinScene';
import { GameOverScene } from './scenes/GameOverScene';

export const VIEWPORT_WIDTH = 375;
export const VIEWPORT_HEIGHT = 667;
export const FELT_GREEN = '#0a3d20';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  width: VIEWPORT_WIDTH,
  height: VIEWPORT_HEIGHT,
  backgroundColor: FELT_GREEN,
  scale: {
    mode: Phaser.Scale.FIT,
    // no autoCenter — CSS flexbox on #game handles centering
  },
  scene: [BootScene, MenuScene, RunStartScene, RoundScene, ShopScene, WinScene, GameOverScene],
};
